import {
  defaultSelectedJobId,
  defaultSourceJobId,
  defaultParams
} from '@/similarJobs/store/defaultState'

export default (
  {
    selected: {
      job: {
        id: selectedJobId = defaultSelectedJobId,
        sourceJobId = defaultSourceJobId
      } = {}
    } = {},
    similarJobs: {
      resultParams: params = defaultParams
    } = {}
  } = {}
) => ({
  selectedJobId,
  sourceJobId,
  params
})
